import styles from "./ResultPaymentPopup.module.scss";

import successIcon from "../../assets/images/icons/success-payment.svg";
import failedIcon from "../../assets/images/icons/failed-payment.svg";
import {useTranslation} from "react-i18next";
import CustomButton from "../UI/CustomButton/CustomButton";

interface IResultPaymentPopupProps {
    type: "success" | "failed",
    title: string,
    description: string,
    clickOnBack: () => void
 }

const ResultPaymentPopup: React.FC<IResultPaymentPopupProps> = ({type, title, description, clickOnBack}) => {

    const {t} = useTranslation();

    return (
        <div className={styles.container}>
            <div className={styles.popup}>
                <img className={styles.image} src={type === "success" ? successIcon : failedIcon} alt={type}/>
                <h3 className={styles.title}>{title}</h3>
                <p className={styles.description}>{description}</p>
                <div className={styles.btnWrapper}>
                    <CustomButton style={{borderRadius: "5px"}} text={t("Back")} type={"button"} typeStyle={"fill"} borderRadius={false} functionOnClick={clickOnBack}/>
                </div>
            </div>
        </div>
    )
}

export default ResultPaymentPopup;